import { Redirect } from 'react-router-dom';
import _ from 'lodash';
import { PageLogin, PageSetup, PageHome, EHandover, BedStatus, DutyAssign, Setting, Detail, Template } from '../page';
import BedstatusSetting from '../page/BedStatus/components/Setting/';
import { Attendance, RelievingPlanning, RosterPlanner } from '../page/DutyAssign/components';
import TemplateEdit from '../page/DutyAssign/components/TemplateEdit';
import AttendanceSetting from '../page/DutyAssign/components/Attendance/Setting';
import Page404 from '../page/PageIndex/Page404';
import { NavMenuE } from '../comm/RoleMap';
import { authNameE } from '../utils/userFuncs';
import Notification from '../page/Notification';
import WardEquipment from '../page/WardEquipment';
import TeleVisit from '../page/TeleVisit';
import WardDrive from '../page/WardDrive';
import EditFloorPlan from '../page/BedStatus/newComponents/EditFloorPlan';
import NewBedStatusSetting from '../page/BedStatus/newComponents/setting/Setting';
import NewBedStatus from '../page/BedStatus/newBedStatus';
import BsSSO from '../page/SSO/bedstatus';
import WpSSO from '../page/SSO/wardplace';
import Admission from '../page/Admission';
import EAdmissionForm from '../page/Admission/EmergencyAdmission/EAdmissionForm';
import WardAssignment from '../page/Admission/EmergencyAdmission/WardAssignment';
import AdmissionSetting from '../page/Admission/AdmissionSetting';
import WardLocation from '../page/Admission/WardLocation';
import Actionable from '../page/Admission/Actionable';
import ActionableDashboard from '../page/Admission/Actionable/ActionableDashboard';
import PatientSurvey from '../page/PatientSurvey';
import PatientSurveyDetail from '../page/PatientSurvey/PatientSurveyDetail';
import TvDashboard from '../page/WardEquipment/TvDashboard';
import EHandoverSetting from '../page/EHandover/components/Setting';
import BedStatusAdmissionDetail from '../page/BedStatus/bsAdmissionDetail';

const RouterMap = {
  others: {
    loginRou: { path: '/login', component: PageLogin, exact: true, key: 2 },
    setupRou: { path: '/setup', component: PageSetup, exact: true, key: 3 },
    defaultRou: { path: '/', exact: true, children: <Redirect to="/login" />, key: 4 },
    Page404Rou: { path: '*', component: Page404, orderBy: -1, key: 5 },
    ssoRou: { path: '/bssso', component: BsSSO, exact: true, key: 26 },
    wpRou: { path: '/wpsso', component: WpSSO, exact: true, key: 27 },
  },
  [authNameE.home]: {
    homeRou: { path: '/home', component: PageHome, exact: true, side: true, key: 6 },
  },
  [authNameE.eHandover]: {
    ehandoverRou: { path: '/ehandover', component: EHandover, exact: true, side: true, key: 7 },
    detailRou: { path: '/ehandover/detail&id=:id&type=:type', component: Detail, exact: true, key: 8 },
    ehandoverSettingRou: { path: '/ehandover/setting', component: EHandoverSetting, exact: true, side: true, key: 41 },
  },
  [authNameE.dutyAssign]: {
    dutyassignRou: { path: '/dutyassign', component: DutyAssign, exact: true, side: true, key: 9 },
    attendanceRou: { path: '/dutyassign/attendance', component: Attendance, exact: true, side: true, key: 10 },
    PlannerRou: { path: '/dutyassign/planner', component: RosterPlanner, exact: true, side: true, key: 11 },
    TemplateRou: { path: '/dutyassign/planner/mytemplate', component: Template, exact: true, side: true, key: 12 },
    TemplateEditRou: {
      path: '/dutyassign/planner/mytemplate/templateEdit',
      component: TemplateEdit,
      exact: true,
      side: true,
      key: 13,
    },
    RelievingPlanningRou: {
      path: '/dutyassign/relieving',
      component: RelievingPlanning,
      exact: true,
      side: true,
      key: 14,
    },
    AttendanceSettingRou: {
      path: '/dutyassign/attendance/setting',
      component: AttendanceSetting,
      exact: true,
      side: true,
      key: 15,
    },
  },
  [authNameE.setting]: {
    settingRou: { path: '/setting', component: Setting, exact: true, side: true, key: 16 },
  },
  [authNameE.bedStatus]: {
    bedstatusRou: { path: '/bedstatus', component: BedStatus, exact: true, side: true, key: 17 },
    bedstatusSettingRou: { path: '/bedstatus/setting', component: BedstatusSetting, exact: true, side: true, key: 18 },
    bedstatusNewRou: { path: '/newBedstatus', component: NewBedStatus, exact: true, side: true, key: 23 },
    bedstatusNewSettingRou: {
      path: '/newBedstatus/setting/:mode',
      component: NewBedStatusSetting,
      exact: true,
      side: true,
      key: 24,
    },
    bedstatusEditFloorPlan: {
      path: '/newBedstatus/editFloorPlan/:id',
      component: EditFloorPlan,
      exact: true,
      side: true,
      key: 25,
    },
    bedstatusFormRou: {
      path: '/bedstatusForm/:id',
      component: EAdmissionForm,
      exact: true,
      side: true,
      key: 33,
    },
    bedstatusActionableRou: {
      path: '/actionableBs',
      component: Actionable,
      exact: true,
      side: true,
      key: 36,
    },
    bedstatusActionableDashboardRou: {
      path: '/actionableDashboardBs',
      component: ActionableDashboard,
      exact: true,
      side: true,
      key: 37,
    },
    bedstatusAdmissionDetailRou: {
      path: '/bsAdmissionDetail/:id',
      component: BedStatusAdmissionDetail,
      exact: true,
      side: true,
      key: 41,
    },
  },
  [authNameE.notification]: {
    notificationRou: {
      path: '/notification',
      component: Notification,
      exact: true,
      side: true,
      key: 19,
    },
  },
  [authNameE.equipment]: {
    equipmentRou: {
      path: '/equipment',
      component: WardEquipment,
      exact: true,
      side: true,
      key: 20,
    },
    equipmentTvDashboardRou: {
      path: '/equipmentTvDashboard',
      component: TvDashboard,
      exact: true,
      side: false,
      key: 40,
    },
  },
  [authNameE.wardDrive]: {
    wardDriveRou: {
      path: '/wardDrive',
      component: WardDrive,
      exact: true,
      side: true,
      key: 21,
    },
  },
  [authNameE.televisit]: {
    televisitRou: {
      path: '/televisit',
      component: TeleVisit,
      exact: true,
      side: true,
      key: 22,
    },
  },
  [authNameE.admission]: {
    admissionRou: {
      path: '/admission',
      component: Admission,
      exact: true,
      side: true,
      key: 28,
    },
    admissionFormRou: {
      path: '/admissionForm/:id',
      component: EAdmissionForm,
      exact: true,
      side: true,
      key: 29,
    },
    admissionWardAssignmentRou: {
      path: '/admissionWardAssignment',
      component: WardAssignment,
      exact: true,
      side: true,
      key: 30,
    },
    admissionSettingRou: {
      path: '/admissionSetting',
      component: AdmissionSetting,
      exact: true,
      side: true,
      key: 31,
    },
    admissionWardLocationRou: {
      path: '/admissionWardLocation/:wardLocation',
      component: WardLocation,
      exact: true,
      side: true,
      key: 32,
    },
    admissionActionableRou: {
      path: '/actionable',
      component: Actionable,
      exact: true,
      side: true,
      key: 34,
    },
    admissionActionableDashboardRou: {
      path: '/actionableDashboardAdm',
      component: ActionableDashboard,
      exact: true,
      side: true,
      key: 35,
    },
  },
  [authNameE.patient_survey]: {
    patientSurveyRou: {
      path: '/patientSurvey',
      component: PatientSurvey,
      exact: true,
      side: true,
      key: 38,
    },
    patientSurveyDetailRou: {
      path: '/patientSurveyDetail',
      component: PatientSurveyDetail,
      exact: true,
      side: true,
      key: 39,
    },
  },
};

const getAllRouterObj = () => {
  const routerObj = {};
  Object.keys(RouterMap).forEach((item) => {
    const itemRouterObj = RouterMap[item];
    if (!itemRouterObj.path) {
      Object.keys(itemRouterObj).forEach((item2) => {
        routerObj[item2] = itemRouterObj[item2];
      });
    } else {
      routerObj[item] = itemRouterObj;
    }
  });
  return routerObj;
};

const getRouterList = (moduleList) => {
  const allRouList = [];
  moduleList.forEach((item) => {
    allRouList.push(...Object.values(RouterMap[item]));
  });
  RouterMap.others.defaultRou = {
    ...RouterMap.others.defaultRou,
    children: (
      <Redirect
        to={
          moduleList[authNameE.home]
            ? RouterMap[authNameE.home].homeRou.path
            : RouterMap[authNameE.setting].settingRou.path
        }
      />
    ),
  };
  allRouList.push(...Object.values(RouterMap.others));
  return _.orderBy(allRouList, (item) => {
    return -(item.orderBy ? item.orderBy : 0);
  });
};

const rouMap = getAllRouterObj();
const isRouListInHome = (moduleList) => {
  const setting = NavMenuE.setting;
  return (
    moduleList?.filter((item) => {
      return item !== setting;
    }).length > 0
  );
};

const isExistPath = (rouList, path) => {
  return _.some(rouList, (item) => {
    return item.path === path;
  });
};
export default rouMap;
export { getRouterList, getAllRouterObj, isRouListInHome, isExistPath };
